<template>
<article class="page-home">
    <section class="overview-section flex align_items__center justify_content__space_between">
      <div class="left-view flex align_items__center">{{$t('欢迎回来，')}}{{userInfo.userName || ''}}</div>

      <div class="right-view">{{dateDesc()}}</div>
    </section>

    <section class="panel-section">
      <div class="panel-title section-stick">{{$t('已订购产品')}}</div>
      <div class="flex flex_wrap__wrap">
        <div class="panel-item flex flex_direction__column align_items__center justify_content__center" v-for="item in purchaseList" :key="item.id">
          <img alt="" :src="item.icon" v-if="item.icon"/>
          <p>{{item.projectCode}}</p>
        </div>
      </div>
    </section>

    <div v-if="pageLoading" v-loading="pageLoading" class="loading-mask"></div>
  </article>
</template>

<script>
import { intl } from "@tci18n/vue2";import { mapGetters } from 'vuex';
import dateHelper from '@/libs/datetime';
import basicHelper from '@/view/common/basic';
import serviceAPI from './api';

/**
 * Home 页面
 * @module @/view/home
 */
export default {
  name: 'Home',
  data() {
    return {
      pageLoading: false,
      purchaseList: [] // 已订购产品列表
    };
  },
  computed: {
    ...mapGetters([
    'userInfo',
    'pageButtonPermission']
    )
  },
  created() {
    this.groupRequestData();
  },
  methods: {
    /**
     * 获取日期文本描述
     */
    dateDesc() {
      let dateNow = new Date();
      const weeks = [intl.$t("星期日"), intl.$t("星期一"), intl.$t("星期二"), intl.$t("星期三"), intl.$t("星期四"), intl.$t("星期五"), intl.$t("星期六")];
      return dateHelper.format(dateNow, intl.$t("MM月dd日")) + ' ' + weeks[dateNow.getDay()];
    },

    /**
     * 组合请求数据
     */
    groupRequestData() {
      const p2 = this.getProductList();
      this.pageLoading = true;
      Promise.all([p2]).then(() => {
        this.pageLoading = false;
      }).catch(() => {
        this.pageLoading = false;
      });
    },

    /**
     * 获取产品列表
     */
    getProductList() {
      serviceAPI.getProductList().then((res) => {
        if (res.code === '200') {
          // 从数据源中过滤“云平台”等项目
          let excludeCodes = [basicHelper.XCLOUD_PROJECT_CODE];
          this.purchaseList = res.data.purchaseList ? res.data.purchaseList.filter((item) => !excludeCodes.includes(item.projectCode)) : [];

          this.purchaseList.forEach((item) => {
            switch (item.projectCode.toLowerCase()) {
              case 'hrms':
                item.icon = require('@/assets/images/icon-hrms.png');
                break;
              case 'pms':
                item.icon = require('@/assets/images/icon-pms.png');
                break;
              case 'mobile':
                item.icon = require('@/assets/images/icon-h5.png');
                break;
              case 'restaurant':
                item.icon = require('@/assets/images/icon-cater.png');
                break;

              default:
                item.icon = '';
            }
          });
        }
      }).catch((exec) => {
        console.error('Get product list exception: ', exec.message);
      });
    },

    /**
     * “新增员工/新建部门”操作
     */
    goCreateOrg(action) {
      this.$router.push({ name: 'organization', params: { action } });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/mixins";
  .page-home {
    padding: 16px;
    position: relative;
  }

  .overview-section {
    padding: 14px 24px 14px 20px;
    background: url("https://file.40017.cn/zhuketong/hrms/image/home_banner.png") no-repeat;
    background-size: 100% 100%;
  }

  .left-view {
    font-size: 20px;
    color: #fff;
    letter-spacing: 0;
    line-height: 20px;
    font-weight: bold;
  }

  .right-view {
    background-color: rgba(120, 158, 248, 0.6);
    border-radius: 20px;
    text-align: center;
    font-size: 16px;
    color: #fff;
    line-height: 1;
    padding: 11px 15px;
  }

  .panel-section {
    @include section-stick($width: 3px, $height: 14px, $pl: 9px);

    min-height: 174px;
    margin-top: 12px;
    padding: 20px 20px 0 20px;
    border-radius: 2px;
    background: #fff;
  }

  .panel-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 16px;
  }

  .panel-item {
    background-color: #fff;
    width: 100px;
    height: 100px;
    margin-right: 16px;
    margin-bottom: 20px;
    text-align: center;
    padding: 0 10px;
    transition: all 0.4s;
    font-size: 12px;
    border-radius: 2px;
    border: 0.69px solid #DEE3EE;
    img {
      max-width: 34px;
      max-height: 34px;
      margin-bottom: 10px;
    }
    &:hover {
      box-shadow: 0 0 6px 0 rgba(73,124,246,0.18);
      border-radius: 1.39px;
      transform:translateY(-4px);
    }
  }

  .loading-mask {
    background-color: rgba(255, 255, 255, 0.6);
    position: absolute;
    top: 16px;
    right: 16px;
    bottom: 16px;
    left: 16px;
  }
</style>
